<h1 style="font-weight: bold;
    font-size: x-large;
    text-align: center;">Trading Plans</h1>
<h6>Issuer:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>{{ config.data.issuerName }}</b></h6>
<h6>Insider:&nbsp;&nbsp;&nbsp;&nbsp;<b>{{ config.data.insiderName }}</b></h6>
<br>
<p-table
  [value]="listOfEntries"
  [first]="first"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="loading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  dataKey="entryId"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th style="width: 20%">Trading Plan Id</th>
      <th style="width: 20%">Plan Action</th>
      <th style="width: 20%">Adoption Date</th>
      <th style="width: 20%">Expiration Date</th>
      <th style="width: 15%">URL</th>
      <th style="width: 20%">Action</th>
    </tr>
  </ng-template>
  <ng-template #body let-share>
    <tr
      [pSelectableRow]="share"
      [ngClass]="{
        'row-duplicate': share.status === 'DUPLICATE',
        'row-excluded': share.status === 'EXCLUDED'
      }"
    >
      <td>{{ share.tradingPlanId || "N/A" }}</td>
      <td>{{ share.planAction || "N/A" }}</td>
      <td>{{ share.adoptionDate || "N/A" }}</td>
      <td>{{ share.expirationDate || "N/A" }}</td>
      <td>
        <a href="{{ share.url }}" *ngIf="share.url" target="_blank"
        >Link</a
        >

        <span *ngIf="!share.adoptionUrl">-</span>
      </td>
      <!--      <td>{{ share.planAction || "N/A" }}</td>-->

      <td class="flex space-x-2">

        <button
          class="bg-white hover:bg-[#2a3450] text-#2a3450 cursor-pointer hover:text-white py-1 px-3 border border-gray-400 rounded mr-2"
          (click)="onSelectClick(share, 'CONNECT')"
          [disabled]="share.status === 'CONNECT'"
        >
          Select
        </button>
      </td>

    </tr>
  </ng-template>
</p-table>


<ng-container
  *ngIf="!loading && listOfEntries.length === 0"
>
  <div class="text-center py-6 text-gray-500">No record found</div>
</ng-container>
